<dynamic-form
  [label]="label"
  [savingLabel]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.PreparationDeliveryTime.Storing' | translate"
  [group]="formGroup"
  [model]="model"
  [submitButtonDisabled]="submitButtonDisabled()"
  [columns]="columns"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <div class="height-custom">
      <time-picker
        name="PreprationDeliveryTime"
        [group]="formGroup"
        required="false"
        textType="numbr"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.PreparationDeliveryTime.DeliveryTime' | translate"></time-picker>
    </div>
  </ng-container>
</dynamic-form>
